export default __webpack_public_path__ + "static/media/CovidTrackerIndonesiaPage.ca8ea42c.PNG";